import { ReactElement, useCallback, useEffect, useState } from 'react';

import { useConnection } from 'modules/auth/hooks/useConnection';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { EMPTY_MODAL_SUCCESS_STATE } from 'modules/liquidStaking/const';
import { IModalSuccessState } from 'modules/liquidStaking/types';

import { useStakeMutation } from '../../../actions/stake';
import { IStakeFormProps, StakeForm } from './StakeForm';

export function Stake(): ReactElement | null {
  const [stake, { isLoading, data: txHash }] = useStakeMutation();
  const { isSafeAccount } = useConnection();

  const { onOpen, isOpened } = useDialog<IModalSuccessState>(
    KnownDialogs.tabStakeSuccess,
  );
  const [successState, setSuccessState] = useState<IModalSuccessState>(
    EMPTY_MODAL_SUCCESS_STATE,
  );

  useEffect(() => {
    if (!isLoading && txHash && !isOpened && !isSafeAccount) {
      onOpen({ ...successState, txHash });
    }
  }, [txHash, isLoading, isOpened, onOpen, successState, isSafeAccount]);

  const handleSubmit: IStakeFormProps['onSubmit'] = useCallback(
    ({ amount, receiveAmount }) => {
      void stake({
        amount,
      });
      setSuccessState({ inAmount: amount, outAmount: receiveAmount });
    },
    [stake],
  );

  return <StakeForm isSubmitLoading={isLoading} onSubmit={handleSubmit} />;
}
